import React from 'react'
import Slider from '../Slider/Slider'

export default function HireNodeDev() {
  return (
    <>
            <div class="inner-page" id="nodejs-design-bg" data-aos="fade-up" data-aos-duration="1500">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5">
                        <div class="inner_content" data-aos="fade-up" data-aos-duration="2000">
                            <h1>Hire Node JS Developer</h1>
                            <div aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a href="index.html"><i
                                                class="ri-home-4-line"></i>Home</a></li>
                                    <li class="breadcrumb-item active" aria-current="page">Hire Node JS</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section class="section" data-aos="fade-up" data-aos-duration="1500">
            <div class="container">
                <div class="heading row_gaping">
                    <h2 class="section-title-2 text-center">Engage Node JS Experts at the Best rates</h2>
                </div>
                <div class="center-row row row-below g-2 row-cols-lg-6 row-cols-sm-3 row-cols-2">
                    <div class="col-md text-center">
                        <div class="hire_content">
                            <img src="assets/image/hire-angular-icon-1.png" alt=""/>
                            <h5>One Week Free Trial</h5>
                        </div>
                    </div>
                    <div class="col-md">
                        <div class="hire_content">
                            <img src="assets/image/hire-angular-icon-2.png" alt=""/>
                            <h5>Minimum 3+ Years of Experience</h5>
                        </div>
                      
                    </div>
                    <div class="col-md">
                        <div class="hire_content">
                            <img src="assets/image/hire-angular-icon-3.png" alt=""/>
                            <h5>Non-Disclosure Agreement</h5>
                      </div>
                    </div>
                    <div class="col-md">
                        <div class="hire_content">
                            <img src="assets/image/hire-angular-icon-4.png" alt=""/>
                          
                            <h5>Flexible Hiring Models</h5>
                       </div>
                    </div>
                    <div class="col-md">
                        <div class="hire_content">
                        <img src="assets/image/hire-angular-icon-5.png" alt=""/>
                           
                        <h5>Competitive Rate</h5>
                        </div>
                    </div>
                    <div class="col-md">
                        <div class="hire_content">
                        <img src="assets/image/hire-angular-icon-6.png" alt=""/>
                        <h5>Source Code Delivery</h5>
                        </div>
                    </div>
                </div>
                <div class="btn_sec text-center row-below">
                    <a href="" class="btn1 btn_gap">Meet The Team</a>
                   <a href="" class="btn3">Recent Projects</a>
                    
                </div>
            </div>
        </section>

        <section class="section hire_content_anguler" data-aos="fade-up" data-aos-duration="1500">
            <div class="small-hire">
                
               <div class="row">
                <div class="col-lg-6 ml-auto">
                    <div class="small_hire_content">
                        <h3>WHAT CAN WE DO FOR YOU?</h3>
                        <p>We would be happy to discuss the project with you in person</p>
                        <h3 class="h3">Call us on <a href="telto:8420197208">+91 8420197208</a> </h3>
                        <div class="btn_sec">
                            <a href="" class="btn2">DROP IN A MESSAGE</a>
                        </div>
                    </div>
                </div>
               </div>
            </div>
        </section>

        <section class="section" data-aos="fade-up" data-aos-duration="1500">
            <div class="container">
               <div class="heading">
                <h2 class="section-title">Hire Offshore Node js Developers to  Meet <br/> Custom Requirements</h2>
                <p class="section-subtitle pt-3">
                    At Adret software, we value diversity and encourage developers from different backgrounds and locations to apply. Embrace the opportunity to work on cutting-edge projects in a collaborative and flexible remote environment.</p>
               </div>

                <div class="row mb-5">
                    <div class="col-md-6 py-2">
                        <div class="bg-white req-card ">
                            <img src="assets/image/hire-angular-icon-7.png" alt=""/>
                            <h6 class="details-heading">Custom Node js Development</h6>
                            <p>Our team of skilled Node js  developers is well-versed in creating custom web applications that stand out in terms of functionality, scalability, and user experience. Whether you need a complete application built from scratch or enhancements to your existing project, we have the expertise to deliver.</p>
                        </div>
                    </div>

                    <div class="col-md-6 py-2">
                        <div class="bg-white req-card ">
                            <img src="assets/image/hire-angular-icon-8.png" alt=""/>
                            <h6 class="details-heading">API Integration</h6>
                            <p class="">Our experienced Node js developers can integrate custom APIs into an
                                application to extend its usability. From shipping to payment gateways to calendars to
                                live chat - we can integrate APIs for a wide range of functionalities.</p>
                        </div>
                    </div>

                    <div class="col-md-6 py-2">
                        <div class="bg-white req-card  ">
                            <img src="assets/image/hire-angular-icon-9.png" alt=""/>
                            <h6 class="details-heading">Ajax Integration</h6>
                            <p class="">Elevate the interactivity and responsiveness of your web applications with our Node.js Ajax integration services at Adret software. Harness the power of asynchronous requests to enhance user experiences and streamline data exchange between your front-end and server..</p>
                        </div>
                    </div>

                    <div class="col-md-6 py-2">
                        <div class="bg-white req-card  ">
                            <img src="assets/image/hire-angular-icon-10.png" alt=""/>
                            <h6 class="details-heading">Migration</h6>
                            <p class="">Hire remote Node js developers to migrate a web application to the latest
                                version of Node js. We adopt relevant migration strategies to simplify the process. Our
                                full-proof migration approach prevents security issues and data loss.</p>
                        </div>
                    </div>
                    <div class="col-md-6 py-2">
                        <div class="bg-white  req-card ">
                            <img src="assets/image/hire-angular-icon-11.png" alt=""/>
                            <h6 class="details-heading">Support & Maintenance</h6>
                            <p class="py-2">Upgrade and future-proof your web applications with our expert Node js migration services at Adret software. We specialize in seamless transitions, ensuring your application stays current, secure, and takes advantage of the latest Node js features.</p>
                        </div>
                    </div>
                    <div class="col-md-6 py-2">
                        <div class="bg-white req-card ">
                            <img src="assets/image/hire-angular-icon-12.png" alt=""/>
                            <h6 class="details-heading">Ecommerce Development</h6>
                            <p class="py-2">Power your online business with our cutting-edge Node.js Ecommerce Development services at Adret software. We specialize in creating robust, scalable, and feature-rich Ecommerce solutions that seamlessly integrate with your business requirements.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section bg_color" data-aos="fade-up" data-aos-duration="1500">
            <div class="container">
              <div class="heading  text-center">
                <h2>Why Choose Us</h2>
              </div>
                <div class="row g-3 ">
                    <div class="col-md-6 col-lg-3">
                        <div class="choose-us  text-center">
                            <div class="choose-us-img">
                                <img src="assets/image/hire-angular-icon-13.png" alt=""/>
                            </div>
                            <h5 class="my-3">Industry Experts</h5>
                            <p>Our in-house team is enriched with trusted and experienced developers - no freelancer.
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3">
                        <div class="choose-us  text-center">
                            <div class="choose-us-img">
                                <img src="assets/image/hire-angular-icon-14.png" alt=""/>
                            </div>
                            <h5 class="my-3">Widely recommended</h5>
                            <p>We got hundreds of real 5-star ratings and reviews on Google, GoodFirms, and Clutch
                                combined. </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3">
                        <div class="choose-us  text-center">
                            <div class="choose-us-img">
                                <img src="assets/image/hire-angular-icon-15.png" alt=""/>
                            </div>
                            <h5 class="my-3">Customer Service
                            </h5>
                            <p>Our zero complaint work approach helps us to ensure a seamless customer experience.


                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3">
                        <div class="choose-us  text-center">
                            <div class="choose-us-img">
                                <img src="assets/image/hire-angular-icon-16.png" alt=""/>
                            </div>
                            <h5 class="my-3">Ideal Workplace
                            </h5>
                            <p>We cultivate a productive work environment with a trendy setup to enhance the outcomes.


                            </p>
                        </div>
                    </div>
                    <div class="row-below btn_sec text-center">
                        <a href="" class="btn2 btn_gap">Get Started</a>
                        <a href="" class="btn2"> Our Clients</a>
                    
                    </div>
                </div>
            </div>
        </section>

        <section class="showcasing_sec" data-aos="fade-up" data-aos-duration="1500">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 text-center">
                        <div class="heading" data-aos="fade-down" data-aos-duration="2500">
                            <h2>Showcasing our Expertise</h2>
                            <p>
                                we pride ourselves on being at the forefront of cutting-edge technology, and our expertise in Node.js is no exception. As industry leaders, we bring a wealth of experience and innovation to every project we undertake.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="owl-carousel owl-theme showcasing_slider">
                            <div class="item">
                                <div class="showcasing_content" data-aos="fade-up" data-aos-duration="2500">
                                    <div class="row g-4">
                                        <div class="col-lg-7">
                                            <div class="heading">
                                                <h4>Web design company in the world</h4>
                                                <p>
                                                    Adret Software takes a client-centric approach to web design. They
                                                    work closely with clients to understand their specific needs and
                                                    goals. They conduct in-depth research to understand the client's
                                                    industry, target audience, and competition.
                                                </p>
                                                <p>
                                                    This allows them to create websites that are tailored to the
                                                    client's needs and stand out from the competition.
                                                </p>
                                                <div class="btn_sec">
                                                    <a href="" class="btn2">View Portfolio</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-5">
                                            <img src="assets/image/home-new-swap-signal.png" class="img-fluid" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="showcasing_content" data-aos="fade-up" data-aos-duration="2500">
                                    <div class="row g-4">
                                        <div class="col-lg-7">
                                            <div class="heading">
                                                <h4>Web Development Technologies</h4>
                                                <p>
                                                    Welcome to Adret software, where we redefine web development using the power of Node.js technologies. Our expert team leverages the latest tools and frameworks to create dynamic, scalable, and high-performance web applications tailored to your unique needs.
                                                </p>
                                                <p>
                                                    Our developers are well-versed in HTML, CSS, JavaScript, and other
                                                   backent technologies, ensuring that every website they develop is
                                                    responsive, visually appealing, and easy to navigate.
                                                </p>
                                                <div class="btn_sec">
                                                    <a href="" class="btn2">View Portfolio</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-5">
                                            <img src="assets/image/home-new-swap-signal.png" class="img-fluid" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="showcasing_content" data-aos="fade-up" data-aos-duration="2500">
                                    <div class="row g-4">
                                        <div class="col-lg-7">
                                            <div class="heading">
                                                <h4> Mobile App Development</h4>
                                                <p>
                                                    Adret Software is a leading mobile app development company in the
                                                    World that provides a wide range of services to clients worldwide.
                                                    With years of experience and expertise in the field, Adret Software
                                                    has earned a reputation for delivering high-quality mobile
                                                    applications that cater to the specific needs of its clients.
                                                </p>
                                                <p>
                                                    In this article on mobile app development services in the World, we
                                                    will explore the services and features that Adret Software offers to
                                                    its clients.
                                                </p>
                                                <div class="btn_sec">
                                                    <a href="" class="btn2">View Portfolio</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-5">
                                            <img src="assets/image/home-new-swap-signal.png" class="img-fluid" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    
        <Slider/>

        <section class="section careers_sec1" id="faq_sec" data-aos="fade-up" data-aos-duration="1500">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="heading">
                            <h2 class="section-title ">Node JS Development – Frequently Asked Question</h2>
                            <p class="section-subtitle">Clarify your doubts about Node JS before availing Node JS
                                development services.</p>
                            <div class="col-md-12">
                                <div class="accordion">

                                    <div class="accordion__item">
                                        <h2 class="accordion__title">How do I get started with your website design
                                            services?</h2>
                                        <div class="accordion__body">
                                            <p> To get started with our website design services, simply contact us to
                                                schedule a consultation. We'll discuss your project requirements and
                                                provide
                                                you with a free quote. Once you're ready to proceed, we'll begin working
                                                on
                                                your website design.</p>
                                        </div>
                                    </div>
                                    <div class="accordion__item">
                                        <h2 class="accordion__title ">How do your website development services benefit
                                            my business?</h2>
                                        <div class="accordion__body">
                                            <p>Our web development services can help your company in a variety of ways.
                                                A well-designed and user-engaging website may boost your online
                                                visibility and credibility. It can also help to automate and simplify
                                                your existing business processes. Ultimately, the high-quality website
                                                that we create for you will help you convert more visitors into
                                                customers and grow your business.</p>
                                        </div>
                                    </div>
                                    <div class="accordion__item">
                                        <h2 class="accordion__title ">Will it be possible to hire website developers on
                                            demand for custom requirements?</h2>
                                        <div class="accordion__body">
                                            <p>At Adret software, we provide the flexibility to hire skilled Node.js developers on demand for a wide range of services, including design, development, and maintenance tasks. Our engagement models are designed to adapt to the complexity and duration of your project, ensuring a seamless collaboration.</p>
                                        </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}
